import { api } from './api';

export interface TeacherTimetableItem {
  dayOfWeek: number; // 1..7 (Mo..So)
  time_start: string; // HH:MM:SS
  time_end: string; // HH:MM:SS
  course_id: number;
  course_name: string;
  fach_id: number;
  fach_name?: string;
  room_id: number | null;
  room_name?: string;
  is_placeholder?: boolean;
  participantsCount: number;
  participantNames?: string; // bereits per ', ' verketteter Anzeige-String
  /** Teilnehmer als Datensätze — nötig für Kontextmenü und Kündigung. */
  participants?: Array<{ subprofileId: string; personId: number; wpUserId: number; subIndex: number; name: string }>;
  startsAt?: string | null; // YYYY-MM-DD
  endsAt?: string | null; // YYYY-MM-DD
  /** Alle n Wochen, gezählt ab der Woche von startsAt (1 = jede Woche). */
  intervall?: number | null;
  startingReason?: 'rule_start' | 'enrollment_start' | null;
  endingReason?: 'rule_until' | 'enrollment_end' | null;
}

export const lehrerTimetableApi = {
  getTimetable: async (teacherId: number | string, reference: string): Promise<TeacherTimetableItem[]> => {
    const url = `/api/lehrer/${encodeURIComponent(String(teacherId))}/timetable?reference=${encodeURIComponent(reference)}`;
    return api.get<TeacherTimetableItem[]>(url);
  },
};


